// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  opId: __t.u64().primaryKey().name("op_id"),
  guildId: __t.u64().name("guild_id"),
  side: __t.u8(),
  civ: __t.string(),
  cyc: __t.u64(),
  campaignId: __t.u64().name("campaign_id"),
  state: __t.string(),
  rulesVersion: __t.u32().name("rules_version"),
  allocJson: __t.string().name("alloc_json"),
  totalSov: __t.i64().name("total_sov"),
  heldSov: __t.i64().name("held_sov"),
  paidSov: __t.i64().name("paid_sov"),
  refundSov: __t.i64().name("refund_sov"),
  fundMotionId: __t.u64().name("fund_motion_id"),
  cancelMotionId: __t.u64().name("cancel_motion_id"),
  proposer: __t.identity(),
  beaconKey: __t.string().name("beacon_key"),
  fundTxId: __t.u64().name("fund_tx_id"),
  payTxId: __t.u64().name("pay_tx_id"),
  settleCause: __t.string().name("settle_cause"),
  history: __t.string(),
  note: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  activeAt: __t.timestamp().name("active_at"),
  cutoffAt: __t.timestamp().name("cutoff_at"),
  settledAt: __t.timestamp().name("settled_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
